import { Field } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { FormFieldConfig } from '../types'

type NewsletterFieldProps = {
  formId: string
  newsletterMandatoryField?: FormFieldConfig
}

export const NewsletterField: FC<NewsletterFieldProps> = ({ formId, newsletterMandatoryField }) => {
  const { t } = useTranslation('forms')

  const getLabel = (): string => {
    const isMandatory = newsletterMandatoryField?.mandatory ?? false
    const baseLabel = t('labels.subscribePlazaBrilliantNews', { ns: 'forms' })

    return isMandatory ? baseLabel : `${baseLabel} - ${t('optional', { ns: 'forms' })}`
  }

  return (
    <Field
      id={`${formId}-newsletter-signup`}
      name="newsletterSignup"
      label={getLabel()}
      field="checkbox"
      gridColumn="span 12"
    />
  )
}
